import { useEffect, useState } from "react";
import { useCrudForm } from "../../../api/useCrudForm";
import { endpoints } from "../../../api/endpoints";
import { toast } from "react-toastify";
import { ProceedBtn } from "../../../components/styledComponent/Button";
import { Fingerprint } from "@mui/icons-material";
import { CircularProgress, Typography } from "@mui/material";
import ImageDisplay from "../../../components/biometric/ImageDisplay";

export const CheckInCheckOut = ({ setIsBlur, isBlur, fingerControl, refetch, handleSubmit, inputType, onCapture, state, setState }: { setIsBlur?: any, isBlur?: any, fingerControl?: any, refetch: any, handleSubmit: any, inputType: any, onCapture: any, state: any, setState: any }) => {

    const [loading, setLoading] = useState(false)
    const { add } = useCrudForm()

    const handleClick = () => {
        fingerControl('enroll', 'ftrapi', 1)
    };

    const endpoint = inputType === 'checkIn' ? endpoints.checkIn.post : endpoints.checkOut.finger

    const onSuccess: (data: any) => void = (data) => {
        if (!state?.fingerTemplate || loading) {
            return
        }
        data = { ...data, fingerTemplate: state.fingerTemplate }
        setLoading(!!data.lockerNumber);
        if (data?.customerId === "") delete data.customerId;
        if (data?.passCode === "") delete data.passCode;
        add({
            endpoints: endpoint,
            onSuccess: (t: any) => {
                toast.success(t.message, { style: { background: '#3150A1' } })
                onCapture(t.data)
                setState({ opId: state.opId })
                if (refetch) {
                    refetch()
                }
                setLoading(false)
                if (setIsBlur) setIsBlur(false)
            },
            onError: (error: any) => {
                toast.error(error)
                setState({ opId: state.opId })
                setLoading(false)
                handleClick()
                if (setIsBlur) setIsBlur(false)
            },
            values: data
        })
    }

    useEffect(() => {
        if (state?.fingerTemplate || isBlur) {
            handleSubmit(onSuccess)()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state?.fingerTemplate, isBlur])

    return (<>
        <ImageDisplay setFingerImage={setState} imageData={state?.uint8Array} message={state?.message} fingerType={'any'} />
        <ProceedBtn disabled={loading} onClick={() => { handleClick() }}>
            {loading ?
                <CircularProgress style={{ width: '20px', height: '20px' }} /> :
                <Fingerprint />
            }
            <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>Capture</Typography>
        </ProceedBtn>
    </>
    )

}